import { DataAccess } from "../../dataaccess/data.access";
import { S25Util } from "../../util/s25-util";

export class S25ChatbotService<TResponse> {
    private config: ChatbotConfig<TResponse>;

    constructor(botKey: keyof typeof CHATBOT_CONFIGS) {
        this.config = CHATBOT_CONFIGS[botKey] as ChatbotConfig<TResponse>;
    }

    public async sendMessage(inputText: string): Promise<TResponse> {
        let payload = { message: inputText };
        let [response, error] = await S25Util.Maybe(DataAccess.post<TResponse>(this.config.requestUrl, payload));
        if (error) {
            return Promise.reject(error);
        }
        return this.config.parseResponse(response);
    }

    public async sendMessageThread(thread: Array<Message>): Promise<TResponse> {
        let payload = { messages: thread };
        let [response, error] = await S25Util.Maybe(DataAccess.post<TResponse>(this.config.requestUrl, payload));

        if (error) {
            return Promise.reject(error);
        }
        return response;
    }
}

export type Message = {
    role: "assistant" | "user";
    content: string;
};

// This shape is the required shape defined in AIRoomRequestController.java (25saas)
export type AiExpressSchedulingResponse = {
    chatResponse: string;
    eventName: string;
    startDate: string;
    endDate: string;
    maximumRoomCapacityNeeded: number;
};

export type AiAdvancedSearchResponse = {
    query: string;
    chatResponse: string;
};

export type AiPricingFormulaResponse = {
    solution: Array<{
        time_range: string;
        duration_range: string;
        formula: string;
        explanation: string;
    }>;
};

type ChatbotConfig<TResponse> = {
    name: string;
    requestUrl: string;
    parseResponse: (raw: any) => TResponse;
};

const CHATBOT_CONFIGS = {
    expressScheduling: {
        requestUrl: "/ai/v2/request.json",
        parseResponse: (raw: any): AiExpressSchedulingResponse => raw,
    } as ChatbotConfig<AiExpressSchedulingResponse>,

    advancedSearch: {
        requestUrl: "/ai/search/request.json",
        parseResponse: (raw: any): AiAdvancedSearchResponse => raw,
    } as ChatbotConfig<AiAdvancedSearchResponse>,

    pricingFormula: {
        requestUrl: "/ai/pricingFormula/request.json",
        parseResponse: (raw: any): AiPricingFormulaResponse => raw,
    } as ChatbotConfig<AiPricingFormulaResponse>,
};
